const get = (path: string) => {
    const url = process.env.REACT_APP_API_OPENROOM_EX_URL + path;
    // const url = `http://localhost:5000${path}`;

    // These public master endpoints do not require custom headers. Keeping this
    // a simple GET also avoids an unnecessary CORS preflight request.
    return fetch(url, { method: 'get' })
        .then(response => {
            if (!response.ok) {
                throw new Error(`学校マスターの取得に失敗しました。(${response.status})`);
            }
            return response.json();
        })
        .then(payload => ({ payload }))
        .catch(error => ({ error }));
};

export const shougakkouList = () => get('/v1/tm/shougakkou/mypage');

export const chuugakkouList = () => get('/v1/tm/chuugakkou/mypage');
